<template>
  <el-upload
    :disabled="disabled"
    ref="uploadForm"
    class="upload-demo"
    :limit="limit"
    :action="uploadUrl"
    :on-preview="previewFun"
    :on-remove="removeFun"
    :headers="{Accept:'application/json, text/plain, */*'}"
    :with-credentials="true"
    :http-request="httpRequest"
    :file-list="self_list">
    <el-button :disabled="disabled" size="small" type="primary">点击上传</el-button>
    <div slot="tip" v-if="!disabled" class="el-upload__tip">只能上传文件，不超过20个文件</div>
  </el-upload>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadFilesSysc",
  props:{
    list:String,
    hostUrl:String,
    uploadUrl:{
      type:String,
      default(){
        return ""
      }
    },
    limit:{
      type:Number,
      default(){
        return 1
      }
    },
    disabled:{
      type:Boolean,
      default(){
        return false
      }
    },
  },
  model: {
    prop: "list", // 定义传递给v-model的那个变量，绑定到哪个属性值上               (默认值value)
    event: "success", // event:什么时候触发v-model行为(让父组件能获取到值)    (默认值input)
  },
  data(){
    return {
      self_list:[],
    }
  },
  created() {
    var that=this;
    this.onListIn();
  },
  methods:{
    onListIn(){
      var that=this;
      if(that.list){
        that.self_list=JSON.parse(this.list)
      }else {
        that.self_list=[];
      }
    },
    removeFun(file, fileList){
      this.self_list=fileList
      this.$emit("success",JSON.stringify(this.self_list))
    },
    previewFun(file){
      window.open(file.url);
    },
    httpRequest(item){
      var that=this;
      let formData = new FormData();
      formData.append("file",item.file);
      __HTTP__.post(item.action,formData).then(res=>{
        if(res){
          item=res.data.data;
          item.url=item.path
          that.self_list.push({name:item.name,url:that.$url(item.url),image:item.url})
          this.$emit("success",JSON.stringify(this.self_list))
        }
      },err=>{
        // that.clearFlies()
      })
    },
    clearFlies() {
      this.$refs.uploadForm.clearFiles();
    },
    $url(url){
      return this.hostUrl+"/"+url;
    }
  },
  watch:{
    list(n){
      this.onListIn();
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(../common.scss);
.file-fm{
  justify-content: space-between;
  width: 300px;
  .file-fm-rt{
    width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/UploadFilesSysc.vue